<div class="w-screen max-w-[280px]"></div>
<div class="grid">
  <div class="flex flex-col justify-between">
    @if (errorMessage()) {
      <div class="mt-4 rounded-md bg-aux-error p-5 font-medium text-white">
        {{ errorMessage() }}
      </div>
    }

    <div>
      <div
        class="btn--hyperlink mb-4 flex cursor-pointer justify-center"
        (click)="downloadPatientTrackerTemplate()"
      >
        Download the template
      </div>

      <aux-file-manager
        #manager
        class="h-48"
        [fetchFilesOnInit]="false"
        [pathFn]="pathFn"
        [eager]="false"
        [metadata]="metadata"
        [showSuccessOnUpload]="true"
      />
    </div>
  </div>

  <div></div>

  <div class="mt-4 max-h-60 overflow-auto">
    <aux-file-viewer
      [fileManager]="manager"
      [disableFirstFileMargin]="true"
      [onlyShowUploaded]="false"
    />
  </div>
</div>
